/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';
import { Breakpoints } from "constants/Breakpoints";
import { Field as FormikField } from 'formik';
import { mediaHelper } from 'utils';


const LoginContainer = styled.div`
  position: relative;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  flex-basis: 0;
  flex-grow: 1;
  padding: 0 0.5rem;

  @media screen and (min-width: ${Breakpoints.sm}) {
    width: 80%;
    padding: 0;
  }
`;

export { LoginContainer };

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 25px;

  // display: flex;
  // margin-top: 1rem;
  // justify-content: center;

  // @media screen and (min-width: ${Breakpoints.sm}) {
  //   justify-content: flex-end;    
  // }

  // @media screen and (min-width: ${Breakpoints.sm}) {
  //   position: absolute;
  //   right: calc(4rem + 4px);
  //   bottom: calc(2rem + 4px);
  }
`;

export { ButtonContainer };

const TextStyled = styled.span`
  text-align: center;
  display: block;
  font-size: 14px;
  color: ${Colors.PRIMARY1};
  margin-top: -16px;

  @media screen and (min-width: ${Breakpoints.sm}) {
    text-align: end;
  }
`;

const Field = styled(FormikField)`
  div:nth-child(3) {
    margin-bottom: 0 !important;
  }
`

const BaseWrapper = styled.div`
  height: 100%;
  background-color1: ${Colors.RED};
  background-color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  ${mediaHelper.lg`
    padding: 0;
  `}
`;

export { TextStyled, Field, BaseWrapper };
